import React, { useState, useEffect } from "react";
import AdminSidebar from "../../component/AdminComp/AdminSidebar";
import AdminTopbar from "../../component/AdminComp/AdminTopbar";
import { Edit, Plus, Trash2 } from "react-feather";
import Swal from "sweetalert2";
import axios from "axios";
import { baseurl, imageUrl } from "../../Baseurl";

const BlogList = () => {
  const [blogs, setBlogs] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredBlogs, setFilteredBlogs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);

  const fetchBlogs = async () => {
    try {
      const res = await axios.get(`${baseurl}GetAllBlogs`);
      setBlogs(res.data || []);
    } catch (error) {
      console.error("Error fetching blogs:", error);
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  useEffect(() => {
    const lowerSearch = searchTerm.toLowerCase();
    const filtered = blogs.filter((blog) =>
      blog.title.toLowerCase().includes(lowerSearch) ||
      blog.category_name.toLowerCase().includes(lowerSearch) ||
      blog.author_name.toLowerCase().includes(lowerSearch)
    );
    setFilteredBlogs(filtered);
    setCurrentPage(1);
  }, [searchTerm, blogs]);

  const handleDelete = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This blog will be deleted permanently!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.delete(`${baseurl}DeleteBlogById/${id}`);
          Swal.fire("Deleted!", "Blog has been deleted.", "success");
          fetchBlogs();
        } catch (error) {
          console.error("Error deleting blog:", error);
          Swal.fire("Error!", "Failed to delete blog.", "error");
        }
      }
    });
  };

  const handleEdit = (id) => {
    window.location.href = `/admin/blog-edit/${id}`;
  };

  // Pagination logic
  const indexOfLast = currentPage * perPage;
  const indexOfFirst = indexOfLast - perPage;
  const currentBlogs = filteredBlogs.slice(indexOfFirst, indexOfLast);
  const totalPages = Math.ceil(filteredBlogs.length / perPage);

  const paginate = (pageNum) => setCurrentPage(pageNum);

  return (
    <div className="App d-flex">
      <AdminSidebar />
      <div className="content flex-grow-1 p-3">
        <AdminTopbar />
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-3">
            <h4>All Blogs</h4>
            <div className="d-flex align-items-center gap-2">
              <input
                type="text"
                className="form-control"
                placeholder="Search title, category, author..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
              <select
                className="form-control w-auto"
                value={perPage}
                onChange={(e) => setPerPage(parseInt(e.target.value))}
              >
                <option value={5}>5  </option>
                <option value={10}>10  </option>
                <option value={25}>25  </option>
                <option value={50}>50 </option>
              </select>
              <a href="/admin/add-blog" className="btn btn-primary linein">
              <Plus size={22}/>  Add Blog
              </a>
            </div>
          </div>

          <div className="table-responsive">
            <table className="custom-table">
              <thead className=" ">
                <tr>
                  <th>#</th>
                  <th>Title</th>
                  <th>Category</th>
                  <th>Author</th>
                  <th>Thumbnail</th>
                  <th>Published</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {currentBlogs.length === 0 ? (
                  <tr>
                    <td colSpan="7" className="text-center">
                      No blogs found.
                    </td>
                  </tr>
                ) : (
                  currentBlogs.map((blog, index) => (
                    <tr key={blog.id}>
                      <td>{indexOfFirst + index + 1}</td>
                      <td>{blog.title}</td>
                      <td>{blog.category_name}</td>
                      <td>{blog.author_name}</td>
                      <td>
                        {blog.thumbnail ? (
                          <img
                            src={`${imageUrl}blog/${blog.thumbnail}`}
                            alt="thumbnail"
                            style={{ width: "60px", height: "auto" }}
                          />
                        ) : (
                          "N/A"
                        )}
                      </td>
                      <td>{blog.is_published ? "Yes" : "No"}</td>
                      <td>
                        <button
                          className="btn btn-sm btnedit me-2"
                          onClick={() => handleEdit(blog.id)}
                        >
                          <Edit size={16} />
                        </button>
                        <button
                          className="btn btn-sm btndelete"
                          onClick={() => handleDelete(blog.id)}
                        >
                          <Trash2 size={16} />
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {totalPages > 1 && (
            <nav className="mt-3">
              <ul className="pagination justify-content-end">
                {Array.from({ length: totalPages }, (_, i) => (
                  <li
                    key={i}
                    className={`page-item ${currentPage === i + 1 ? "active" : ""}`}
                  >
                    <button className="page-link" onClick={() => paginate(i + 1)}>
                      {i + 1}
                    </button>
                  </li>
                ))}
              </ul>
            </nav>
          )}
        </div>
      </div>
    </div>
  );
};

export default BlogList;
